module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block",
    class: _vm.addClasses
  }, [_c('h2', {
    staticClass: "block__subheader"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "block__text"
  }, [_vm._t("default"), (_vm.video && _vm.videoContent.length) ? _vm._l((_vm.videoContent), function(movie, index) {
    return _c('div', {
      key: index,
      staticClass: "block__video",
      domProps: {
        "innerHTML": _vm._s(movie)
      }
    })
  }) : _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-036e9c7a","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/block/Block.vue
// module id = 2c6bf1abd5c997b56bd9
// module chunks = 0